module.exports = __webpack_public_path__ + "static/media/playlist-remove.92f9d2f7.svg";